// extracted by mini-css-extract-plugin
export default {"resend-button":"style_resend-button__l9jn-","resendButton":"style_resend-button__l9jn-"};